<template>
    <template v-for="(video,videoKey,index) in ($route.name == 'wallet-deposit' ? walletConfig.deposit_video : walletConfig.withdrawal_video)" :key="index">
        <div class="div_outer_box" v-if="video">
          <div class="deposit_demo_video_section" >
                  <div class="custom_container">
                      <div class="withdraws_video_sec">
                          <div>
                              <div class="withdraws-video-con">
                                  <div class="video_thm_title">
                                      <h2>{{ $t(`how-to-${type == 2 ? 'deposit' : 'withdraw'}`, `How To ${type == 2 ? 'Deposit' : 'Withdraw'}`) }} ({{ videoKey }})</h2>
                                  </div>
                                   <iframe :src="video" :title="videoKey" frameborder="0" allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                                  </div>
                          </div>
                      </div>
                  </div>
              </div>
     </div>
    </template>
</template>
<script>
export default {
    name: 'TutorialVideo',
      props:['type'],
    inject: ['walletConfig'],
}
</script>